import { resolveUsers, resolveUser } from './resolvers/users.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.users', {
            url: '/users',
            component: 'userList',
            resolve: {
                users: resolveUsers()
            },
            roles: ['admin']
        })
        .state('app.admin.user-add', {
            url: '/users/create',
            component: 'userSave',
            resolve: {
                title: () => 'Create a User',
            },
            roles: ['admin']
        })
        .state('app.admin.user-edit', {
            url: '/users/:targetuser/update',
            component: 'userSave',
            resolve: {
                title: () => 'Update a User',
                targetuser: resolveUser(),
            },
            roles: ['admin']
        })
        .state('app.admin.user-password', {
            url: '/users/:targetuser/change-password',
            component: 'userPassword',
            resolve: {
                title: () => 'Change password',
                targetuser: resolveUser()
            },
            roles: ['admin', 'superadmin']
        })
        .state('app.password', {
            url: '/password',
            component: 'userSelfpassword',
            resolve: {
                title: () => 'Change Your Password',
            }
        })
        .state('app.profile', {
            url: '/profile',
            component: 'userProfile',
            resolve: {
                title: () => 'Edit Your Details',
                targetuser: resolveUser()
            }
        })
        .state('app.admin.setPasswordEmails', {
            url: '/set-password-emails',
            component: 'setPasswordEmail',
            roles: ['admin']
        })
        ;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/user.routes.js